export const PAGE_SIZE = 5;
export const columnsWidth = {
  readingType: 360,
  assign: 172,
};
